export enum EPaymentType {
  Concept,
  Advance
}
